module.exports = __webpack_public_path__ + "static/media/civicwatchMungo.ac20e281.png";